import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Chatbot from "react-chatbot-kit";
import "react-chatbot-kit/build/main.css";
import config from "./config";
import MessageParser from "./MessageParser";
import ActionProvider from "./ActionProvider";
import "./ChatbotWidget.css";
import BotAvatar from "./BotAvatar";

const ChatbotWidget = () => {
  const isMobile = window.innerWidth <= 768;
  const [showChat, setShowChat] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="chatbot-container">
      {showChat && (
        <div className="chatbot-box">
          <div className="chatbot-body">
            <Chatbot
              config={config}
              messageParser={MessageParser}
              actionProvider={ActionProvider}
            />
          </div>
        </div>
      )}

      <button
        className="chatbot-toggle"
        onClick={() => {
          isMobile ? navigate("/chatbot") : setShowChat(!showChat);
        }}
      >
        <BotAvatar />
      </button>
    </div>
  );
};

export default ChatbotWidget;